// extracted by mini-css-extract-plugin
export default {"colorCatskillWhite":"#F1F6F9","divider":"iYFPVljB1TfroRXLcxFB"};